import { Validators, AbstractControl } from '@angular/forms';

export const requiredIf = (predicate: Function, customErrorName?: string) => {
  return (formControl: AbstractControl) => {
    if (!formControl.parent) {
      return null;
    }
    if (predicate()) {
      if (customErrorName) {
        return { [customErrorName]: true };
      } else {
        return Validators.required(formControl);
      }
    }
    return null;
  };
};
